import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import * as actions from 'store/actions';
import { faEnvelope, faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as cTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/ConfigTypes';
import "./Contact.scss";

const Contact = (props) => {
    const [data, setData] = useState([]);
    const fm = (id) => props.intl.formatMessage({ id });

    useEffect(() => {
        if (props.data) setData(props.data);
    }, [props.data]);


    const getHeadline = () => {
        let txt = fm('login.contact');
        if (props.heading) txt = props.heading;
        let img = <FontAwesomeIcon icon={faEnvelope} />;
        if (props.logo) img = <img src={props.logo} />
        return (
            <h1 className="contact-heading">
                {img}
                {txt}
            </h1>
        )
    }

    const getSubTxt = () => {
        if (props.subtxtItems) {
            return props.subtxtItems.map(item => {
                return (<div>{fm(item.intl)}</div>)
            })
        }
        return null;
    }

    const backToLogin = () => {
        return (
            <Link to={"/login"} className='contact-login'>
                <div className="contact-member contact-btn">
                    <FontAwesomeIcon icon={faSignInAlt} />
                    {fm('auth.backToLogin')}
                </div>
            </Link>
        )
    }

    const showLink = ({ item }) => {
        return (
            <div className="contact-linkbox">
                {item.before && <span>{fm(item.before)}</span>}
                <a className="contact-link" href={`mailto:${item.link}`}>{item.link}</a>
                {item.after && <span>{fm(item.after)}</span>}
                {item.link02 && (<a className="contact-link" href={`mailto:${item.link02}`}>{item.link02}</a>)}
            </div>
        )
    }

    const showText = ({ item }) => {
        return (
            <p>
                {item.before && (
                    <span className={item.beforeClasses ? item.beforeClasses : null}>{fm(item.before)}</span>
                )}
                <span className={item.htmlClasses ? item.htmlClasses : null}>{fm(item.intl)}</span>
                {item.after && (
                    <span className={item.afterClasses ? item.afterClasses : null}>{fm(item.after)}</span>
                )}
            </p>
        )
    }

    const showItem = ({ item }) => {
        if (item.type === cTypes.HEADLINE) return (
            <h2 className="contact-headline">
                {item.icon && <FontAwesomeIcon icon={item.icon} />}
                {fm(item.intl)}
            </h2>
        )
        if (item.type === cTypes.LINK) return showLink({ item });
        if (item.type == cTypes.BREAKLINE) return <div className="contact-breakline"></div>
        return showText({ item });
    }

    const showDataItem = ({ item, i }) => {
        if (item && item.data && item.data.length) {
            return (
                <div className="contact-item">
                    {showItem({ item })}
                    <div className="contact-item-data">
                        {item.data.map(el => showItem({ item: el }))}
                    </div>
                </div>
            )
        }
        return showItem({ item })
    }

    return (
        <div className="contact-hero-bg">
            <div className="contact-box">
                <div className="contact-wrapper">
                    <div className="contact-top">
                        {getHeadline()}
                        <div className="contact-subtxt">
                            {getSubTxt()}
                        </div>
                    </div>
                    <div className="contact-form">
                        {(data && data.length) && data.map((item, i) => showDataItem({ item, i }))}
                        {backToLogin()}
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    // authObjects: state.auth.authObjects,
});

const mapDispatchToProps = (dispatch) => ({
    register: (obj) => dispatch(actions.register(obj))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Contact));
